import { IWebsites } from '@/models/websites.model';
import { Button } from '@/ui';
import { PenIcon, TrashIcon } from '@/icons';
import { TableColumnsType } from 'antd';
import { TFunction } from 'i18next';
import { StyledButtons } from '../components';

export const getWebsitesTableConfig = (
  t: TFunction,
  onEdit?: (record: IWebsites) => void,
  onDelete?: (record: IWebsites) => void,
): TableColumnsType<IWebsites> => [
  {
    title: t('label_title'),
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: t('label_description'),
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: t('label_link'),
    dataIndex: 'url',
    key: 'url',
    render: (url) => (
      <a href={url} target="_blank" style={{ width: '100%' }} rel="noreferrer">
        {url}
      </a>
    ),
  },
  {
    title: t('label_active'),
    dataIndex: 'status',
    key: 'status',
    render: (status: string) => <p>{status}</p>,
  },
  {
    title: t('column_action'),
    key: 'action',
    width: 150,
    render: (_, record) => (
      <StyledButtons>
        <Button icon={<PenIcon />} type="primary" size="small" block onClick={() => onEdit?.(record)} />
        <Button icon={<TrashIcon />} type="primary" size="small" danger block onClick={() => onDelete?.(record)} />
      </StyledButtons>
    ),
  },
];
